import UserPage from "./user-page";

export default UserPage;



